import { cfGetAuthHeaders } from '@/io/apis/cfAuth'

const CF_API = () => `${(import.meta as any).env.VITE_APP_CF_API_URL || ''}/api`

const createFetchRequest = async (endpoint: string, options: RequestInit = {}) => {
  const url = endpoint.startsWith('http') ? endpoint : `${CF_API()}/${endpoint}`

  const defaultHeaders = await cfGetAuthHeaders()

  const response = await fetch(url, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  return response.json()
}

const buildQueryString = (params: Record<string, string>) => {
  const searchParams = new URLSearchParams(params)
  return searchParams.toString()
}

const get = (id: string) => {
  const queryString = buildQueryString({ id })
  return createFetchRequest(`user?${queryString}`)
}

const collectionDataQuery = async itemtype => {
  const headers = await cfGetAuthHeaders()

  const result = await fetch(`${CF_API()}/content`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ itemtype }),
  })

  if (!result.ok) {
    throw new Error(`HTTP error! status: ${result.status}`)
  }
  const data = await result.json()
  return data
}

const getItemDownloadLink = async (itch_userid, game_id, item_uri) => {
  const headers = await cfGetAuthHeaders()

  let url = `${CF_API()}/content`
  url += `?itch_userid=${itch_userid}&game_id=${game_id}&item_uri=${item_uri}`

  const result = await fetch(url, {
    method: 'GET',
    headers,
    cache: 'no-store',
  })

  if (!result.ok) {
    throw new Error(`HTTP error! status: ${result.status}`)
  }
  const data = await result.json()
  return data
}

export { get, collectionDataQuery, getItemDownloadLink }
